import { CircularProgress } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    divLoading: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
});

const Loading = (props) => {
    const classes = useStyles();
    const { description } = props;

    return (
        <div className={classes.divLoading}>
            <CircularProgress color="primary" {...props} />
            <p>{description}</p>
        </div>

    );
}

export default Loading;